import { Column, DataType } from '@miq/catalog';
import { EMPTY_STRING, MiqMoment } from '@miq/utils';
import { isMasked, formatNumbers } from '../../../../shared/utils/functions';

export type PVExcelEntry = Pick<Column, 'header' | 'dataType' | 'displayFn' | 'lookupCategory' | 'values'> & {
  key: string;
};

export const COLUMNS: PVExcelEntry[] = [
  { header: 'Tenant', key: 'tenant', dataType: DataType.Text },
  { header: 'Tenant Industry', key: 'tenant_industry', dataType: DataType.Text },
  { header: 'Floor', key: 'floor_number', dataType: DataType.Text },
  {
    header: 'Entire/Partial Floor',
    key: 'full_floor',
    dataType: DataType.Text,
    lookupCategory: '/lookup/yn',
    values: [
      { key: 'Y', value: 'Entire' },
      { key: 'N', value: 'Partial' },
    ],
  },
  { header: 'Suite', key: 'suite_number', dataType: DataType.Text },
  { header: 'Space Size', key: 'size', dataType: DataType.Text },
  { header: 'Type', key: 'type', dataType: DataType.Text },
  { header: 'Start Date', key: 'tenancy_start_date', dataType: DataType.Date },
  { header: 'End Date', key: 'tenancy_end_date', dataType: DataType.Date },
  { header: 'RTC (Year)', key: 'arrangement_signed_date', dataType: DataType.Text },
  { header: 'RTC Tenant Rep', key: 'tenant_reps', dataType: DataType.Text },
  { header: 'Actual', key: 'lease_record_type_desc', dataType: DataType.Text },
  { header: 'Option', key: 'option', dataType: DataType.Text },
  {
    header: 'TIM',
    key: 'active_tim',
    dataType: DataType.Text,
    lookupCategory: '/lookup/yn',
    values: [
      { key: true, value: 'Y' },
      { key: false, value: 'N' },
    ],
  },
];

export const BG_COLORS = Object.freeze({
  HEADER: '5081BD',
  ODD: 'DCE6F1',
  EVEN: 'FFFFFF',
});

export const DATA_TYPE_FORMATTERS = {
  [DataType.Date]: (value: any) =>
    value != null && !isMasked(value) && value !== EMPTY_STRING ? MiqMoment.format(value, 'MM/YYYY') : value,
  [DataType.Numeric]: (value: any) => formatNumbers(value, '0.0'),
};
